import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

export abstract class GameNameVerticalBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** 内边距 */
  ['--game-name-vertical-padding']?: string;
  /** 上方logo的宽度 */
  ['--top-logo-width']?: string;
  /** 上方logo的高度 */
  ['--top-logo-height']?: string;
  /** 下方文字的字号 */
  ['--bottom-name-font-size']?: string;
  /** 游戏下方文字加粗设置 */
  ['--game-name-font-weight']?: string
}
